module.exports = __webpack_public_path__ + "img/banner.b0edf15b.png";